import { ObservableMap } from 'owa-mobx4-adapter';
import { createStore } from 'satcheljs';
var defaultMailFavoritesViewState = {
    contextMenuState: null,
    shouldShowFindFavoritesPicker: false,
};
var defaultMailFavoritesStore = {
    mailFavoritesViewState: defaultMailFavoritesViewState,
    favoritePersonasRootFolderId: undefined,
    isFavoritingInProgress: new ObservableMap({}),
    favoriteNodeViewStates: new ObservableMap({}),
};
export var getStore = createStore('mailFavorites', defaultMailFavoritesStore);
export default getStore();
//# sourceMappingURL=store.js.map